<template>
  <div class="favorites-section">
    <div class="section-header">
      <div class="section-title">
        <span class="material-symbols-outlined star-icon">star</span>
        <h3>Your Favourite Routes</h3>
      </div>
      <span class="routes-count">{{ favoriteRouteObjects.length }}</span>
    </div>
    
    <div class="favorites-grid">
      <div
        v-for="route in favoriteRouteObjects"
        :key="route.id"
        class="favorite-card">
        <div class="card-header">
          <div class="route-info">
            <div class="route-name-row">
              <span class="material-symbols-outlined">directions_bus</span>
              <h4 class="route-name">{{ route.name }}</h4>
              <button @click="$emit('toggleFavorite', route.id)" class="unfavorite-btn" title="Remove from favorites">
                <span class="material-symbols-outlined" style="font-variation-settings: 'FILL' 1;">star</span>
              </button>
            </div>
            <div class="buses-row">
              <span v-for="bus in route.buses" :key="bus" class="bus-number">
                {{ bus }}
              </span>
            </div>
          </div>
        </div>

        <div class="card-body">
          <div v-if="getNextBus(route).nextTime !== null" class="next-bus-display" :class="getNextBus(route).color">
            <div class="next-bus-content">
              <span class="material-symbols-outlined next-bus-icon">schedule</span>
              <div class="next-bus-details">
                <span class="next-bus-label">Next Bus</span>
                <span class="next-bus-time">{{ getNextBus(route).timeStr }}</span>
                <span class="next-bus-countdown">{{ getNextBus(route).countdownStr }}</span>
              </div>
            </div>
          </div>
          <div v-else class="no-bus-display">
            <span class="material-symbols-outlined">event_busy</span>
            <span>No more buses today</span>
          </div>
          
          <div class="day-info">
            <span class="material-symbols-outlined">calendar_today</span>
            <span>{{ getNextBus(route).dayInfo }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "FavoriteRoutes",
  props: {
    favoriteRoutes: Array,
    routes: Array,
    getNextBus: Function
  },
  computed: {
    favoriteRouteObjects() {
      return this.routes.filter(r => this.favoriteRoutes.includes(r.id));
    }
  }
};
</script>

<style scoped>
.favorites-section {
  background: linear-gradient(135deg, #fffbeb 0%, #fef3c7 100%);
  border-radius: 16px;
  padding: 1.5rem;
  margin-bottom: 2rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  border: 2px solid #fde68a;
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.25rem;
}

.section-title {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.star-icon {
  color: #f59e0b;
  font-size: 32px;
  font-variation-settings: 'FILL' 1;
  filter: drop-shadow(0 2px 4px rgba(245, 158, 11, 0.3));
}

.section-title h3 {
  font-size: 1.5rem;
  font-weight: 700;
  color: #92400e;
  margin: 0;
}

.routes-count {
  background: white;
  color: #92400e;
  padding: 0.5rem 1rem;
  border-radius: 10px;
  font-weight: 700;
  font-size: 1.125rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.favorites-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  gap: 1.25rem;
}

.favorite-card {
  background: white;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
  border: 1px solid #fef3c7;
}

.favorite-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.12);
}

.card-header {
  background: linear-gradient(135deg, #fef3c7 0%, #fde68a 100%);
  padding: 1.25rem;
  border-bottom: 2px solid #fbbf24;
}

.route-info {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.route-name-row {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.route-name-row .material-symbols-outlined {
  color: #1e40af;
  font-size: 24px;
}

.route-name {
  flex: 1;
  font-size: 1.125rem;
  font-weight: 700;
  color: #1f2937;
  margin: 0;
}

.unfavorite-btn {
  background: rgba(245, 158, 11, 0.2);
  border: none;
  border-radius: 8px;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
}

.unfavorite-btn:hover {
  background: rgba(245, 158, 11, 0.3);
  transform: scale(1.1);
}

.unfavorite-btn .material-symbols-outlined {
  color: #f59e0b;
  font-size: 20px;
}

.buses-row {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.bus-number {
  padding: 0.375rem 0.75rem;
  background: linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%);
  color: #1e40af;
  border-radius: 6px;
  font-size: 0.875rem;
  font-weight: 700;
  border: 1px solid #93c5fd;
}

.card-body {
  padding: 1.25rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.next-bus-display {
  border-radius: 10px;
  padding: 1rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.next-bus-display.bg-green-600 {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
  color: white;
}

.next-bus-display.bg-yellow-500 {
  background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);
  color: white;
}

.next-bus-display.bg-red-600 {
  background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
  color: white;
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}

.next-bus-content {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.next-bus-icon {
  font-size: 48px;
}

.next-bus-details {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  flex: 1;
}

.next-bus-label {
  font-size: 0.75rem;
  opacity: 0.9;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  font-weight: 600;
}

.next-bus-time {
  font-size: 1.5rem;
  font-weight: 700;
}

.next-bus-countdown {
  font-size: 0.875rem;
  opacity: 0.9;
}

.no-bus-display {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
  padding: 1.25rem;
  background: #f3f4f6;
  color: #6b7280;
  border-radius: 10px;
  font-weight: 600;
}

.no-bus-display .material-symbols-outlined {
  font-size: 32px;
}

.day-info {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 0.75rem;
  background: #f9fafb;
  border-radius: 8px;
  font-size: 0.875rem;
  color: #6b7280;
  font-weight: 500;
}

.day-info .material-symbols-outlined {
  font-size: 18px;
}

@keyframes pulse {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.8;
  }
}

@media (max-width: 640px) {
  .favorites-section {
    padding: 1.25rem;
  }

  .section-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 1rem;
  }

  .section-title h3 {
    font-size: 1.25rem;
  }

  .favorites-grid {
    grid-template-columns: 1fr;
  }
}
</style>

